import { ready } from '../global/instantiate';
import truncateText from '../sections/products/truncate';

ready(() => {
  truncateText();
});